/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CognitoStrictHttpResponse } from '../../cognito-strict-http-response';
import { CognitoRequestBuilder } from '../../cognito-request-builder';

import { CognitoCognitoUserCreateDto } from '../../models/cognito-cognito-user-create-dto';
import { CognitoCognitoUserResponseDto } from '../../models/cognito-cognito-user-response-dto';

export interface CognitoControllerCreateUser$Params {

/**
 * The tenant identifier
 */
  tenant: string;
      body: CognitoCognitoUserCreateDto
}

export function cognitoControllerCreateUser(http: HttpClient, rootUrl: string, params: CognitoControllerCreateUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>> {
  const rb = new CognitoRequestBuilder(rootUrl, cognitoControllerCreateUser.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CognitoStrictHttpResponse<CognitoCognitoUserResponseDto>;
    })
  );
}

cognitoControllerCreateUser.PATH = '/o2-cognito/cognito/users/{tenant}';
